<template>
    <div class="automations">
        <div class="automations-layout">

            <div class="d-none d-sm-block automations-menu">
                <ul class="tabs-2nd-level">
                    <li ref="automationTypeTimed" v-on:click="showTimedAutomations" v-bind:class="{'tabs-2nd-level--selected' : isTabTimed}"><i class="d-block d-lg-none fas fa-clock"></i><span class="d-none d-lg-block">Time driven</span></li>
                    <li ref="automationTypeEvent" v-on:click="showEventAutomations" v-bind:class="{'tabs-2nd-level--selected' : isTabEvent}"><i class="d-block d-lg-none fas fa-question"></i><span class="d-none d-lg-block">Event driven</span></li>
                </ul>
            </div>

            <div class="automations-content">

                <ul class="d-block d-sm-none pills ml-auto mr-auto">
                    <li class="pills__pill" v-on:click="showTimedAutomations" v-bind:class="{'pills__pill--active': isTabTimed}">
                        <span>Time driven</span>
                    </li>
                    <li class="pills__pill" v-on:click="showEventAutomations" v-bind:class="{'pills__pill--active': isTabEvent}">
                        <span>Event driven</span>
                    </li>
                </ul>


                <!-- ======================================================================================= -->
                <!-- ======================================================================================= -->
                <!--                                                                                         -->
                <!-- TIME DRIVEN                                                                             -->
                <!--                                                                                         -->
                <!-- ======================================================================================= -->
                <!-- ======================================================================================= -->
                <template v-if="isTabTimed">

                    <div class="row automations__title">
                        <div class="col-4 col-sm-6 col-md-8">
                            <h2><span class="d-none d-sm-inline">Time driven </span><span class="d-none d-md-inline">automations</span></h2>
                        </div>
                        <div class="col-8 col-sm-6 col-md-4 automations__view-selector">
                            <h5>View</h5>
                            <i v-on:click="changeViewFlow(true)"
                                class="fas fa-sitemap automations__view-selector__toggle automations__view-selector__toggle--first"
                                v-bind:class="{'automations__view-selector__toggle--on': showFlow, 'automations__view-selector__toggle--off': !showFlow}"></i>
                            <i v-on:click="changeViewFlow(false)"
                                class="fas automations__view-selector__toggle fa-list automations__view-selector__toggle--last"
                                v-bind:class="{'automations__view-selector__toggle--on': !showFlow, 'automations__view-selector__toggle--off': showFlow}"></i>
                        </div>
                    </div>


                    <div class="automations__view">

                        <!-- ======================================================================================= -->
                        <!-- DESKTOP VIEW                                                                            -->
                        <!-- ======================================================================================= -->

                        <div class="d-none d-md-flex automations__view--desktop">

                            <div class="automations-heading" v-show="showFlow">
                                <div class="automations-heading__event">
                                </div>
                                <div class="automations-heading__journey">
                                    <h3>Timeline</h3>
                                </div>
                                <div class="automations-heading__automations">
                                    <h3>Automations</h3>
                                </div>
                            </div>

                            <div ref="scrollContainerDesktop" class="automations-list-scrollable">


                            <!-- -------------- -->
                            <!-- BOOKING PLACED -->
                            <!-- -------------- -->

                            <!--  --------------------------------- -->
                            <!--  Automations on day booking placed -->
                            <!--  --------------------------------- -->
                            <div class="automation-event automation-event--first" v-show="showFlow">
                                <div class="automation-event-timeline-arrow automation-event-timeline-arrow-in">
                                    <i class="fas fa-angle-right"></i>
                                </div>

                                <div class="automation-event-timeline">
                                    <div class="automation-event-timeline-line automation-event-timeline-line--top"></div>
                                    <div ref="timelineBookingPlaced" class="automation-event-timeline-event">
                                        <i class="far fa-calendar-alt"></i>
                                        Booking<br>
                                        Placed
                                    </div>
                                    <div class="automation-event-timeline-line"></div>
                                </div>

                                <!-- RELATED (SEE BELOW): Only show the first group of automations here, if its numberOfDaysFrom = 0 -->
                                <div v-if="afterBookingGroups.length > 0 && afterBookingGroups[0].numberOfDaysFrom === 0" class="automation-event-timeline-group">
                                    <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                        <i class="fas fa-angle-right"></i>
                                    </div>

                                    <div class="automation-event-timeline-group automation-event-timeline-group__automations-list">
                                        <timed-automation2 v-for="(automation, automationIndex) in afterBookingGroups[0].groupedByTypeAndCommunicationMode[0].automations"
                                                           v-bind:key="automation.reference"
                                                           v-bind:automation="automation"
                                                           v-bind:hideToggle="hideAutomationToggle(automation)"
                                                           v-bind:index="automationIndex"
                                                           @scroll-to-automation="(top, left) => scrollToAutomation(top, left, 'scrollContainerDesktop')"/>
                                    </div>
                                </div>

                                <div v-if="afterBookingGroups.length === 0" class="automation-event-timeline-group automation-event-timeline-group--add-automation">
                                    <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                        <i class="fas fa-angle-right"></i>
                                    </div>

                                    <div class="automation-event-timeline-add-automation">
                                        <button ref="addAutomation" v-on:click.stop="addAutomation('after-booking')" class="btn btn-primary">Add an Automation</button>
                                        <span>to execute <b>after Booking</b></span>
                                    </div>
                                </div>
                            </div>

                            <!-- Show the other groups of automation if there are any -->
                            <div v-show="showFlow" v-if="afterBookingGroups.length > 0 && afterBookingGroups[0].numberOfDaysFrom === 0 && afterBookingGroups[0].groupedByTypeAndCommunicationMode.length > 1">
                                <div class="automation-event" v-for="(groupByName, index) in afterBookingGroups[0].groupedByTypeAndCommunicationMode.slice(1)" v-bind:key="'after-booking' + '_0_' + index">
                                    <div class="automation-event-timeline-arrow automation-event-timeline-arrow-none">
                                    </div>

                                    <div class="automation-event-timeline">
                                        <div class="automation-event-timeline-line automation-event-timeline-line--top"></div>
                                        <div class="automation-event-timeline-line"></div>
                                    </div>

                                    <div class="automation-event-timeline-group-of-groups">
                                        <div class="automation-event-timeline-group">
                                            <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                                <i class="fas fa-angle-right"></i>
                                            </div>

                                            <div class="automation-event-timeline-group automation-event-timeline-group__automations-list">
                                                <timed-automation2 v-for="(automation, automationIndex) in groupByName.automations"
                                                                   v-bind:key="automation.reference"
                                                                   v-bind:automation="automation"
                                                                   v-bind:hideToggle="hideAutomationToggle(automation)"
                                                                   v-bind:previousAutomation="groupByName[automationIndex-1]"
                                                                   v-bind:nextAutomation="groupByName[automationIndex+1]"
                                                                   v-bind:index="automationIndex"
                                                                   @scroll-to-automation="(top, left) => scrollToAutomation(top, left, 'scrollContainerDesktop')"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--  -------------------------------- -->
                            <!--  Automations after booking placed -->
                            <!--  -------------------------------- -->
                            <div v-show="showFlow" v-for="(groupByTime) in afterBookingGroups" v-bind:key="'after-booking' + '_' + groupByTime.numberOfDaysFrom">
                                <template v-if="groupByTime.numberOfDaysFrom > 0">
                                    <div class="automation-event" v-for="(groupByName, index) in groupByTime.groupedByTypeAndCommunicationMode" v-bind:key="'after-booking' + '_' + groupByTime.numberOfDaysFrom + '_' + index">
                                        <div class="automation-event-timeline-arrow automation-event-timeline-arrow-none">
                                        </div>

                                        <div v-if="index == 0" class="automation-event-timeline">
                                            <div class="automation-event-timeline-line automation-event-timeline-line--top"></div>
                                            <div class="automation-event-timeline-event automation-event-timeline-event--text-only">
                                                <b>{{groupByTime.numberOfDaysFrom}}</b><br/>
                                                Day<template v-if="Math.abs(groupByTime.numberOfDaysFrom) > 1">s</template><br/>
                                                After
                                            </div>
                                            <div class="automation-event-timeline-line"></div>
                                        </div>
                                        <div v-else class="automation-event-timeline">
                                            <div class="automation-event-timeline-line automation-event-timeline-line--top"></div>
                                            <div class="automation-event-timeline-line"></div>
                                        </div>

                                        <div class="automation-event-timeline-group">
                                            <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                                <i class="fas fa-angle-right"></i>
                                            </div>

                                            <div class="automation-event-timeline-group automation-event-timeline-group__automations-list">
                                                <timed-automation2 v-for="(automation, automationIndex) in groupByName.automations"
                                                                   v-bind:key="automation.reference"
                                                                   v-bind:automation="automation"
                                                                   v-bind:hideToggle="hideAutomationToggle(automation)"
                                                                   v-bind:previousAutomation="groupByName[automationIndex-1]"
                                                                   v-bind:nextAutomation="groupByName[automationIndex+1]"
                                                                   v-bind:index="automationIndex"
                                                                   @scroll-to-automation="(top, left) => scrollToAutomation(top, left, 'scrollContainerDesktop')"/>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <!--  -------------------------- -->
                            <!-- Button to add an automation -->
                            <!--  -------------------------- -->
                            <div v-if="afterBookingGroups.length > 0" class="automation-event" v-show="showFlow">
                                <div class="automation-event-timeline-arrow automation-event-timeline-arrow-none"></div>

                                <div class="automation-event-timeline">
                                    <div class="automation-event-timeline-line"></div>
                                </div>

                                <div class="automation-event-timeline-group automation-event-timeline-group--add-automation">
                                    <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                        <i class="fas fa-angle-right"></i>
                                    </div>

                                    <div class="automation-event-timeline-add-automation">
                                        <button ref="addAutomation" v-on:click.stop="addAutomation('after-booking')" class="btn btn-primary">Add an Automation</button>
                                        <span>to execute <b>after Booking</b></span>
                                    </div>
                                </div>
                            </div>

                            <!--  Joining line  -->
                            <div class="automation-event" v-show="showFlow">
                                <div class="automation-event-timeline-arrow automation-event-timeline-arrow-none"></div>

                                <div class="automation-event-timeline">
                                    <div class="automation-event-timeline-line automation-event-timeline-line--joiner"></div>
                                </div>
                            </div>



                            <!-- -------------- -->
                            <!-- CHECK-IN       -->
                            <!-- -------------- -->

                            <!--  --------------------------------- -->
                            <!--  Show "Add and Automation" button? -->
                            <!--  --------------------------------- -->
                            <div v-if="showAddAutomationButtonBefore(beforeCheckInGroups, afterCheckInGroups)" class="automation-event" v-show="showFlow">
                                <div class="automation-event-timeline-arrow automation-event-timeline-arrow-none"></div>

                                <div class="automation-event-timeline">
                                    <div class="automation-event-timeline-line"></div>
                                </div>

                                <div class="automation-event-timeline-group automation-event-timeline-group--add-automation">
                                    <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                        <i class="fas fa-angle-right"></i>
                                    </div>

                                    <div class="automation-event-timeline-add-automation">
                                        <button v-on:click.stop="addAutomation('after-check-in')" class="btn btn-primary">Add an Automation</button>
                                        <span>to execute <b>before</b> or <b>after Check-In</b></span>
                                    </div>
                                </div>
                            </div>

                            <!--  --------------------------- -->
                            <!--  Automations before check-in -->
                            <!--  --------------------------- -->
                            <div v-show="showFlow" v-for="(groupByTime) in beforeCheckInGroups" v-bind:key="'before-check-in' + '_' + groupByTime.numberOfDaysFrom">
                                <div class="automation-event" v-for="(groupByName, index) in groupByTime.groupedByTypeAndCommunicationMode" v-bind:key="'before-check-in' + '_' + groupByTime.numberOfDaysFrom + '_' + index">
                                    <div class="automation-event-timeline-arrow automation-event-timeline-arrow-none"></div>

                                    <div v-if="index == 0" class="automation-event-timeline">
                                        <div class="automation-event-timeline-line automation-event-timeline-line--top"></div>
                                        <div class="automation-event-timeline-event automation-event-timeline-event--text-only">
                                            <b>{{Math.abs(groupByTime.numberOfDaysFrom)}}</b><br/>
                                            Day<template v-if="Math.abs(groupByTime.numberOfDaysFrom) > 1">s</template><br/>
                                            Before
                                        </div>
                                        <div class="automation-event-timeline-line"></div>
                                    </div>
                                    <div v-else class="automation-event-timeline">
                                        <div class="automation-event-timeline-line automation-event-timeline-line--top"></div>
                                        <div class="automation-event-timeline-line"></div>
                                    </div>

                                    <div class="automation-event-timeline-group">
                                        <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                            <i class="fas fa-angle-right"></i>
                                        </div>

                                        <div class="automation-event-timeline-group automation-event-timeline-group__automations-list">
                                            <timed-automation2 v-for="(automation, automationIndex) in groupByName.automations"
                                                               v-bind:key="automation.reference"
                                                               v-bind:automation="automation"
                                                               v-bind:hideToggle="hideAutomationToggle(automation)"
                                                               v-bind:previousAutomation="groupByName[automationIndex-1]"
                                                               v-bind:nextAutomation="groupByName[automationIndex+1]"
                                                               v-bind:index="automationIndex"
                                                               @scroll-to-automation="(top, left) => scrollToAutomation(top, left, 'scrollContainerDesktop')"/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--  ----------------------- -->
                            <!--  Automations at check-in -->
                            <!--  ----------------------- -->
                            <div class="automation-event automation-event-next-flow" v-show="showFlow">
                                <div class="automation-event-timeline-arrow automation-event-timeline-arrow-none">
                                </div>

                                <div class="automation-event-timeline">
                                    <div class="automation-event-timeline-line"></div>
                                    <div class="automation-event-timeline-event">
                                        <i class="fas fa-walking automation-process-event__icon--person"></i>
                                        <i class="fas fa-door-open fa-flip-horizontal"></i>
                                        Check-In
                                    </div>
                                    <div class="automation-event-timeline-line"></div>
                                </div>

                                <!-- If there are automation on day of check-in, only show the first group, if there
                                is one - else the Check-in pill is middle aligned which is confusing -->
                                <div v-if="afterCheckInGroups.length > 0 && afterCheckInGroups[0].numberOfDaysFrom === 0">
                                    <div class="automation-event-timeline-group">
                                        <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                            <i class="fas fa-angle-right"></i>
                                        </div>

                                        <div class="automation-event-timeline-group automation-event-timeline-group__automations-list">
                                            <timed-automation2 v-for="(automation, automationIndex) in afterCheckInGroups[0].groupedByTypeAndCommunicationMode[0].automations"
                                                               v-bind:key="automation.reference"
                                                               v-bind:automation="automation"
                                                               v-bind:hideToggle="hideAutomationToggle(automation)"
                                                               v-bind:previousAutomation="afterCheckInGroups[0].groupedByTypeAndCommunicationMode[0].automations[automationIndex-1]"
                                                               v-bind:nextAutomation="afterCheckInGroups[0].groupedByTypeAndCommunicationMode[0].automations[automationIndex+1]"
                                                               v-bind:index="automationIndex"
                                                               @scroll-to-automation="(top, left) => scrollToAutomation(top, left, 'scrollContainerDesktop')"/>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="showAddAutomationButtonAt(beforeCheckInGroups, afterCheckInGroups)" class="automation-event-timeline-group automation-event-timeline-group--add-automation">
                                    <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                        <i class="fas fa-angle-right"></i>
                                    </div>

                                    <div class="automation-event-timeline-add-automation">
                                        <button v-on:click.stop="addAutomation('after-check-in')" class="btn btn-primary">Add an Automation</button>
                                        <span>to execute <b>before</b> or <b>after Check-In</b></span>
                                    </div>
                                </div>
                            </div>

                            <!-- Show the other groups of automation if there are any -->
                            <div v-show="showFlow" v-if="afterCheckInGroups.length > 0 && afterCheckInGroups[0].numberOfDaysFrom === 0 && afterCheckInGroups[0].groupedByTypeAndCommunicationMode.length > 1">
                                <div class="automation-event" v-for="(groupByName, index) in afterCheckInGroups[0].groupedByTypeAndCommunicationMode.slice(1)" v-bind:key="'after-check-in' + '_0_' + index">
                                    <div class="automation-event-timeline-arrow automation-event-timeline-arrow-none"></div>

                                    <div class="automation-event-timeline">
                                        <div class="automation-event-timeline-line automation-event-timeline-line--top"></div>
                                        <div class="automation-event-timeline-line"></div>
                                    </div>

                                    <div class="automation-event-timeline-group">
                                        <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                            <i class="fas fa-angle-right"></i>
                                        </div>

                                        <div class="automation-event-timeline-group automation-event-timeline-group__automations-list">
                                            <timed-automation2 v-for="(automation, automationIndex) in groupByName.automations"
                                                               v-bind:key="automation.reference"
                                                               v-bind:automation="automation"
                                                               v-bind:hideToggle="hideAutomationToggle(automation)"
                                                               v-bind:previousAutomation="groupByName[automationIndex-1]"
                                                               v-bind:nextAutomation="groupByName[automationIndex+1]"
                                                               v-bind:index="automationIndex"
                                                               @scroll-to-automation="(top, left) => scrollToAutomation(top, left, 'scrollContainerDesktop')"/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--  -------------------------- -->
                            <!--  Automations after check-in -->
                            <!--  -------------------------- -->
                            <div v-show="showFlow" v-for="(groupByTime) in afterCheckInGroups" v-bind:key="'after-check-in' + '_' + groupByTime.numberOfDaysFrom">
                                <template v-if="groupByTime.numberOfDaysFrom > 0">
                                    <div class="automation-event" v-for="(groupByName, index) in groupByTime.groupedByTypeAndCommunicationMode" v-bind:key="'after-check-in' + '_' + groupByTime.numberOfDaysFrom + '_' + index">
                                        <div class="automation-event-timeline-arrow automation-event-timeline-arrow-none"></div>

                                        <div v-if="index == 0" class="automation-event-timeline">
                                            <div class="automation-event-timeline-line automation-event-timeline-line--top"></div>
                                            <div class="automation-event-timeline-event automation-event-timeline-event--text-only">
                                                <b>{{groupByTime.numberOfDaysFrom}}</b><br/>
                                                Day<template v-if="Math.abs(groupByTime.numberOfDaysFrom) > 1">s</template><br/>
                                                After
                                            </div>
                                            <div class="automation-event-timeline-line"></div>
                                        </div>
                                        <div v-else class="automation-event-timeline">
                                            <div class="automation-event-timeline-line automation-event-timeline-line--top"></div>
                                            <div class="automation-event-timeline-line"></div>
                                        </div>

                                        <div class="automation-event-timeline-group">
                                            <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                                <i class="fas fa-angle-right"></i>
                                            </div>

                                            <div class="automation-event-timeline-group automation-event-timeline-group__automations-list">
                                                <timed-automation2 v-for="(automation, automationIndex) in groupByName.automations"
                                                                   v-bind:key="automation.reference"
                                                                   v-bind:automation="automation"
                                                                   v-bind:hideToggle="hideAutomationToggle(automation)"
                                                                   v-bind:previousAutomation="groupByName[automationIndex-1]"
                                                                   v-bind:nextAutomation="groupByName[automationIndex+1]"
                                                                   v-bind:index="automationIndex"
                                                                   @scroll-to-automation="(top, left) => scrollToAutomation(top, left, 'scrollContainerDesktop')"/>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <!--  --------------------------------- -->
                            <!--  Show "Add and Automation" button? -->
                            <!--  --------------------------------- -->
                            <div v-if="showAddAutomationButtonAfter(beforeCheckInGroups, afterCheckInGroups)" class="automation-event" v-show="showFlow">
                                <div class="automation-event-timeline-arrow automation-event-timeline-arrow-none"></div>

                                <div class="automation-event-timeline">
                                    <div class="automation-event-timeline-line"></div>
                                </div>

                                <div class="automation-event-timeline-group automation-event-timeline-group--add-automation">
                                    <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                        <i class="fas fa-angle-right"></i>
                                    </div>

                                    <div class="automation-event-timeline-add-automation">
                                        <button v-on:click.stop="addAutomation('after-check-in')" class="btn btn-primary">Add an Automation</button>
                                        <span>to execute <b>before</b> or <b>after Check-In</b></span>
                                    </div>
                                </div>
                            </div>

                            <!--  Joining line  -->
                            <div class="automation-event" v-show="showFlow">
                                <div class="automation-event-timeline-arrow automation-event-timeline-arrow-none"></div>

                                <div class="automation-event-timeline">
                                    <div class="automation-event-timeline-line automation-event-timeline-line--joiner"></div>
                                </div>
                            </div>



                            <!-- -------------- -->
                            <!-- CHECK-OUT      -->
                            <!-- -------------- -->

                            <!--  --------------------------------- -->
                            <!--  Show "Add and Automation" button? -->
                            <!--  --------------------------------- -->
                            <div v-if="beforeCheckOutGroups.length > 0 || (afterCheckOutGroups.length > 0 && afterCheckOutGroups[0].numberOfDaysFrom === 0)" class="automation-event" v-show="showFlow">
                                <div class="automation-event-timeline-arrow automation-event-timeline-arrow-none"></div>

                                <div class="automation-event-timeline">
                                    <div class="automation-event-timeline-line"></div>
                                </div>

                                <div class="automation-event-timeline-group automation-event-timeline-group--add-automation">
                                    <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                        <i class="fas fa-angle-right"></i>
                                    </div>

                                    <div class="automation-event-timeline-add-automation">
                                        <button v-on:click.stop="addAutomation('after-check-out')" class="btn btn-primary">Add an Automation</button>
                                        <span>to execute <b>before</b> or <b>after Check-Out</b></span>
                                    </div>
                                </div>
                            </div>

                            <!--  ---------------------------- -->
                            <!--  Automations before check-out -->
                            <!--  ---------------------------- -->
                            <div v-show="showFlow" v-for="(groupByTime) in beforeCheckOutGroups" v-bind:key="'before-check-out' + '_' + groupByTime.numberOfDaysFrom">
                                <div class="automation-event" v-for="(groupByName, index) in groupByTime.groupedByTypeAndCommunicationMode" v-bind:key="'before-check-out' + '_' + groupByTime.numberOfDaysFrom + '_' + index">
                                    <div class="automation-event-timeline-arrow automation-event-timeline-arrow-none"></div>

                                    <div v-if="index == 0" class="automation-event-timeline">
                                        <div class="automation-event-timeline-line automation-event-timeline-line--top"></div>
                                        <div class="automation-event-timeline-event automation-event-timeline-event--text-only">
                                            <b>{{Math.abs(groupByTime.numberOfDaysFrom)}}</b><br/>
                                            Day<template v-if="Math.abs(groupByTime.numberOfDaysFrom) > 1">s</template><br/>
                                            Before
                                        </div>
                                        <div class="automation-event-timeline-line"></div>
                                    </div>
                                    <div v-else class="automation-event-timeline">
                                        <div class="automation-event-timeline-line automation-event-timeline-line--top"></div>
                                        <div class="automation-event-timeline-line"></div>
                                    </div>

                                    <div class="automation-event-timeline-group">
                                        <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                            <i class="fas fa-angle-right"></i>
                                        </div>

                                        <div class="automation-event-timeline-group automation-event-timeline-group__automations-list">
                                            <timed-automation2 v-for="(automation, automationIndex) in groupByName.automations"
                                                               v-bind:key="automation.reference"
                                                               v-bind:automation="automation"
                                                               v-bind:hideToggle="hideAutomationToggle(automation)"
                                                               v-bind:previousAutomation="groupByName[automationIndex-1]"
                                                               v-bind:nextAutomation="groupByName[automationIndex+1]"
                                                               v-bind:index="automationIndex"
                                                               @scroll-to-automation="(top, left) => scrollToAutomation(top, left, 'scrollContainerDesktop')"/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--  ------------------------ -->
                            <!--  Automations at check-out -->
                            <!--  ------------------------ -->
                            <div class="automation-event automation-event-next-flow" v-show="showFlow">
                                <div class="automation-event-timeline-arrow automation-event-timeline-arrow-none">
                                </div>

                                <div class="automation-event-timeline">
                                    <div class="automation-event-timeline-line"></div>
                                    <div class="automation-event-timeline-event">
                                        <i class="fas fa-door-open"></i>
                                        <i class="fas fa-walking automation-process-event__icon--person"></i>
                                        Check-Out
                                    </div>
                                    <div class="automation-event-timeline-line"></div>
                                </div>

                                <!-- If there are automation on day of check-out, only show the first group, if there
                                is one - else the Check-out pill is middle aligned which is confusing -->
                                <div v-if="afterCheckOutGroups.length > 0 && afterCheckOutGroups[0].numberOfDaysFrom === 0">
                                    <div class="automation-event-timeline-group">
                                        <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                            <i class="fas fa-angle-right"></i>
                                        </div>

                                        <div class="automation-event-timeline-group automation-event-timeline-group__automations-list">
                                            <timed-automation2 v-for="(automation, automationIndex) in afterCheckOutGroups[0].groupedByTypeAndCommunicationMode[0].automations"
                                                               v-bind:key="automation.reference"
                                                               v-bind:automation="automation"
                                                               v-bind:hideToggle="hideAutomationToggle(automation)"
                                                               v-bind:previousAutomation="afterCheckOutGroups[0].groupedByTypeAndCommunicationMode[0].automations[automationIndex-1]"
                                                               v-bind:nextAutomation="afterCheckOutGroups[0].groupedByTypeAndCommunicationMode[0].automations[automationIndex+1]"
                                                               v-bind:index="automationIndex"
                                                               @scroll-to-automation="(top, left) => scrollToAutomation(top, left, 'scrollContainerDesktop')"/>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="beforeCheckOutGroups.length === 0 && afterCheckOutGroups.length === 0" class="automation-event-timeline-group automation-event-timeline-group--add-automation">
                                    <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                        <i class="fas fa-angle-right"></i>
                                    </div>

                                    <div class="automation-event-timeline-add-automation">
                                        <button v-on:click.stop="addAutomation('after-check-out')" class="btn btn-primary">Add an Automation</button>
                                        <span>to execute <b>before</b> or <b>after Check-Out</b></span>
                                    </div>
                                </div>
                            </div>

                            <!-- Show the other groups of automation if there are any -->
                            <div v-show="showFlow" v-if="afterCheckOutGroups.length > 0 && afterCheckOutGroups[0].numberOfDaysFrom === 0 && afterCheckOutGroups[0].groupedByTypeAndCommunicationMode.length > 1">
                                <div class="automation-event" v-for="(groupByName, index) in afterCheckOutGroups[0].groupedByTypeAndCommunicationMode.slice(1)" v-bind:key="'after-check-out' + '_0_' + index">
                                    <div class="automation-event-timeline-arrow automation-event-timeline-arrow-none"></div>

                                    <div class="automation-event-timeline">
                                        <div class="automation-event-timeline-line automation-event-timeline-line--top"></div>
                                        <div class="automation-event-timeline-line"></div>
                                    </div>

                                    <div class="automation-event-timeline-group">
                                        <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                            <i class="fas fa-angle-right"></i>
                                        </div>

                                        <div class="automation-event-timeline-group automation-event-timeline-group__automations-list">
                                            <timed-automation2 v-for="(automation, automationIndex) in groupByName.automations"
                                                               v-bind:key="automation.reference"
                                                               v-bind:automation="automation"
                                                               v-bind:hideToggle="hideAutomationToggle(automation)"
                                                               v-bind:previousAutomation="groupByName[automationIndex-1]"
                                                               v-bind:nextAutomation="groupByName[automationIndex+1]"
                                                               v-bind:index="automationIndex"
                                                               @scroll-to-automation="(top, left) => scrollToAutomation(top, left, 'scrollContainerDesktop')"/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--  --------------------------- -->
                            <!--  Automations after check-out -->
                            <!--  --------------------------- -->
                            <div v-show="showFlow" v-for="(groupByTime) in afterCheckOutGroups" v-bind:key="'after-check-out' + '_' + groupByTime.numberOfDaysFrom">
                                <template v-if="groupByTime.numberOfDaysFrom > 0">
                                    <div class="automation-event" v-for="(groupByName, index) in groupByTime.groupedByTypeAndCommunicationMode" v-bind:key="'after-check-out' + '_' + groupByTime.numberOfDaysFrom + '_' + index">
                                        <div class="automation-event-timeline-arrow automation-event-timeline-arrow-none"></div>

                                        <div v-if="index == 0" class="automation-event-timeline">
                                            <div class="automation-event-timeline-line automation-event-timeline-line--top"></div>
                                            <div class="automation-event-timeline-event automation-event-timeline-event--text-only">
                                                <b>{{groupByTime.numberOfDaysFrom}}</b><br/>
                                                Day<template v-if="Math.abs(groupByTime.numberOfDaysFrom) > 1">s</template><br/>
                                                After
                                            </div>
                                            <div class="automation-event-timeline-line"></div>
                                        </div>
                                        <div v-else class="automation-event-timeline">
                                            <div class="automation-event-timeline-line automation-event-timeline-line--top"></div>
                                            <div class="automation-event-timeline-line"></div>
                                        </div>

                                        <div class="automation-event-timeline-group">
                                            <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                                <i class="fas fa-angle-right"></i>
                                            </div>

                                            <div class="automation-event-timeline-group automation-event-timeline-group__automations-list">
                                                <timed-automation2 v-for="(automation, automationIndex) in groupByName.automations"
                                                                   v-bind:key="automation.reference"
                                                                   v-bind:automation="automation"
                                                                   v-bind:hideToggle="hideAutomationToggle(automation)"
                                                                   v-bind:previousAutomation="groupByName[automationIndex-1]"
                                                                   v-bind:nextAutomation="groupByName[automationIndex+1]"
                                                                   v-bind:index="automationIndex"
                                                                   @scroll-to-automation="(top, left) => scrollToAutomation(top, left, 'scrollContainerDesktop')"/>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <!--  --------------------------------- -->
                            <!--  Show "Add and Automation" button? -->
                            <!--  --------------------------------- -->
                            <div v-if="afterCheckOutGroups.length > 0 || (afterCheckOutGroups.length > 0 && afterCheckOutGroups[0].numberOfDaysFrom === 0)" class="automation-event" v-show="showFlow">
                                <div class="automation-event-timeline-arrow automation-event-timeline-arrow-none"></div>

                                <div class="automation-event-timeline">
                                    <div class="automation-event-timeline-line"></div>
                                </div>

                                <div class="automation-event-timeline-group automation-event-timeline-group--add-automation">
                                    <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                        <i class="fas fa-angle-right"></i>
                                    </div>

                                    <div class="automation-event-timeline-add-automation">
                                        <button v-on:click.stop="addAutomation('after-check-out')" class="btn btn-primary">Add an Automation</button>
                                        <span>to execute <b>before</b> or <b>after Check-Out</b></span>
                                    </div>
                                </div>
                            </div>

                            <div class="automation-event" v-show="showFlow">
                                <div class="automation-event-timeline-arrow automation-event-timeline-arrow-none"></div>

                                <div class="automation-event-timeline">
                                    <div class="automation-event-timeline-line automation-event-timeline-line--joiner"></div>
                                </div>
                            </div>

                            </div>

                        </div>



                        <!-- ======================================================================================= -->
                        <!-- MOBILE VIEW                                                                            -->
                        <!-- ======================================================================================= -->

                        <div class="col-12 d-block d-md-none automations__view--mobile">
                            <div class="row automations-container" v-show="showFlow">
                                <div class="col-lg-4 col-12">
                                    <div class="automation-flow">
                                        <h3>Booking</h3>

                                        <div class="automation automation-process-event automation-process-event--no-before">
                                            <div class="card">
                                                <div class="card-header">
                                                    <i class="far fa-calendar-alt"></i>
                                                </div>
                                                <div class="card-body">
                                                    <span class="automation-title__name">Booking Placed</span>
                                                </div>
                                            </div>
                                            <div class="add-automation">
                                                <i v-on:click.stop="addAutomation('after-booking', 0)" class="fas fa-plus add-automation-button"></i>
                                                <i class="fas fa-arrow-down add-automation-arrow"></i>
                                            </div>
                                        </div>

                                        <automation v-for="(automation, index) in afterBooking"
                                                    v-bind:key="automation.reference"
                                                    v-bind:automation="automation"
                                                    v-bind:hideToggle="hideAutomationToggle(automation)"
                                                    v-bind:previousAutomation="afterBooking[index-1]"
                                                    v-bind:nextAutomation="afterBooking[index+1]"
                                                    v-bind:index="index"
                                                    v-bind:beforeProcessEvent="false"
                                                    @scroll-to-automation="(top, left) => scrollToAutomation(top, left, 'scrollContainerMobile')"/>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-12">
                                    <div class="automation-flow">
                                        <h3>Check-In</h3>

                                        <automation v-for="(automation, index) in beforeCheckIn"
                                                    v-bind:key="automation.reference"
                                                    v-bind:automation="automation"
                                                    v-bind:hideToggle="hideAutomationToggle(automation)"
                                                    v-bind:previousAutomation="beforeCheckIn[index-1]"
                                                    v-bind:nextAutomation="beforeCheckIn[index+1]"
                                                    v-bind:index="index"
                                                    v-bind:beforeProcessEvent="true"
                                                    @scroll-to-automation="(top, left) => scrollToAutomation(top, left, 'scrollContainerMobile')"/>

                                        <div class="automation automation-process-event">
                                            <div class="add-automation">
                                                <i v-on:click.stop="addAutomation('before-check-in', 0)" class="fas fa-plus add-automation-button"></i>
                                                <i class="fas fa-arrow-down add-automation-arrow"></i>
                                            </div>
                                            <div class="card">
                                                <div class="card-header">
                                                    <!--                                <i class="fas fa-door-open"></i>-->
                                                    <i class="fas fa-walking automation-process-event__icon--person"></i>
                                                    <i class="fas fa-door-open fa-flip-horizontal"></i>
                                                </div>
                                                <div class="card-body">
                                                    <span class="automation-title__name">Check-In</span>
                                                </div>
                                            </div>
                                            <div class="add-automation">
                                                <i v-on:click.stop="addAutomation('after-check-in', 0)" class="fas fa-plus add-automation-button"></i>
                                                <i class="fas fa-arrow-down add-automation-arrow"></i>
                                            </div>
                                        </div>

                                        <automation v-for="(automation, index) in afterCheckIn"
                                                    v-bind:key="automation.reference"
                                                    v-bind:automation="automation"
                                                    v-bind:hideToggle="hideAutomationToggle(automation)"
                                                    v-bind:index="index"
                                                    v-bind:previousAutomation="afterCheckIn[index-1]"
                                                    v-bind:nextAutomation="afterCheckIn[index+1]"
                                                    v-bind:beforeProcessEvent="false"
                                                    @scroll-to-automation="(top, left) => scrollToAutomation(top, left, 'scrollContainerMobile')"/>
                                    </div>

                                </div>

                                <div class="col-lg-4 col-12">
                                    <div class="automation-flow">
                                        <h3>Check-Out</h3>

                                        <automation v-for="(automation, index) in beforeCheckOut"
                                                    v-bind:key="automation.reference"
                                                    v-bind:automation="automation"
                                                    v-bind:hideToggle="hideAutomationToggle(automation)"
                                                    v-bind:previousAutomation="beforeCheckOut[index-1]"
                                                    v-bind:nextAutomation="beforeCheckOut[index+1]"
                                                    v-bind:index="index"
                                                    v-bind:beforeProcessEvent="true"
                                                    @scroll-to-automation="(top, left) => scrollToAutomation(top, left, 'scrollContainerMobile')"/>

                                        <div class="automation automation-process-event">
                                            <div class="add-automation">
                                                <i v-on:click.stop="addAutomation('before-check-out', 0)" class="fas fa-plus add-automation-button"></i>
                                                <i class="fas fa-arrow-down add-automation-arrow"></i>
                                            </div>
                                            <div class="card">
                                                <div class="card-header">
                                                    <!--                                <i class="fas fa-door-closed"></i>-->
                                                    <i class="fas fa-door-open"></i>
                                                    <i class="fas fa-walking automation-process-event__icon--person"></i>
                                                </div>
                                                <div class="card-body">
                                                    <span class="automation-title__name">Check-Out</span>
                                                </div>
                                            </div>
                                            <div class="add-automation">
                                                <i v-on:click.stop="addAutomation('after-check-out')" class="fas fa-plus add-automation-button"></i>
                                                <i class="fas fa-arrow-down add-automation-arrow"></i>
                                            </div>
                                        </div>

                                        <automation v-for="(automation, index) in afterCheckOut"
                                                    v-bind:key="automation.reference"
                                                    v-bind:automation="automation"
                                                    v-bind:hideToggle="hideAutomationToggle(automation)"
                                                    v-bind:previousAutomation="afterCheckOut[index-1]"
                                                    v-bind:nextAutomation="afterCheckOut[index+1]"
                                                    v-bind:index="index"
                                                    v-bind:beforeProcessEvent="false"
                                                    @scroll-to-automation="(top, left) => scrollToAutomation(top, left, 'scrollContainerMobile')"/>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>



                    <!-- ======================================================================================= -->
                    <!-- TABULAR VIEW                                                                            -->
                    <!-- ======================================================================================= -->


                    <div class="tabular-container" v-if="!showFlow">
                        <table class="tabular">
                            <thead>
                            <th class="head-performed">
                                <span class="d-inline d-sm-none"><i class="fas fa-clock"></i></span>
                                <span class="d-none d-sm-inline"><i class="fas fa-clock"></i> Performed</span>
                            </th>
                            <th class="head-flow">
                                <span class="d-inline d-sm-none"><i class="fas fa-sitemap"></i></span>
                                <span class="d-none d-sm-inline"><i class="fas fa-sitemap"></i> Flow</span>
                            </th>
                            <th class="head-i"></th>
                            <th class="head-type">
                                <span class="d-inline d-sm-none"><i class="fas fa-envelope"></i></span>
                                <span class="d-none d-sm-inline">Type</span>
                            </th>
                            <th class="">
                                <span class="d-none d-sm-inline">Name</span>
                            </th>
                            <th class="head-customize">
                                <span class="d-inline d-sm-none"><i class="fas fa-cog"></i></span>
                                <span class="d-none d-sm-inline"><i class="fas fa-cog"></i>Customise</span>
                            </th>
                            <th class="head-active">
                                <span class="d-inline d-sm-none"><i class="fas fa-power-off"></i></span>
                                <span class="d-none d-sm-inline"><i class="fas fa-power-off"></i>Active</span>
                            </th>
                            <th class="head-active">
                                <span class="d-inline d-sm-none"><i class="fas fa-trash-alt"></i></span>
                                <span class="d-none d-sm-inline"><i class="fas fa-trash-alt"></i>Delete</span>
                            </th>
                            </thead>
                            <template v-if="automations">
                                <template v-for="flow in flows">
                                    <tr v-for="(automation) in flow" v-bind:key="automation.reference" class="form-summary">
                                        <td class="text-center">{{whenStrategy(automation.when)}}</td>
                                        <td>{{automationFlow(automation.when)}}</td>
                                        <td v-html="automationTypeAsIcon(automation.type)" class="automation-type"></td>
                                        <td>{{automationTypeAsString(automation.type)}}</td>
                                        <td>{{automation.name}}</td>
                                        <td class="automation-actions text-center">
                                            <button v-if="isAnAutomationWithAForm(automation)" class="btn btn-primary btn-small center" v-on:click="openFormTemplate(automation)"><i class="fab fa-wpforms" aria-hidden="true"></i></button>
                                            <button v-if="isAnAutomationWithAnEmail(automation)" class="btn btn-primary btn-small center" v-on:click="openEmailTemplate(automation)"><i class="far fa-envelope" aria-hidden="true"></i></button>
                                            <button v-if="isAnAutomationWithAnSMS(automation)" class="btn btn-primary btn-small center" v-on:click="openSMSTemplate(automation)"><i class="fas fa-sms" aria-hidden="true"></i></button>
                                        </td>
                                        <td class="automation-active text-center">
                                            <template v-if="!hideAutomationToggle(automation)">
                                                <i v-if="automation.active" v-on:click="automation.active = false" class="fas fa-toggle-on automation-active--on"></i>
                                                <i v-if="!automation.active" v-on:click="automation.active = true" class="fas fa-toggle-off automation-active--off"></i>
                                            </template>
                                        </td>
                                        <td>

                                        </td>
                                    </tr>
                                </template>
                            </template>
<!--                                <tr>-->
<!--                                    <td colspan="7" class="actions text-center"><button v-on:click.stop="addAutomation('after-booking')" class="btn btn-primary center">Add automation</button></td>-->
<!--                                </tr>-->
                        </table>
                        <div v-show="loading">
                            <Spinner/>
                        </div>
                        <div v-show="!loading">
                            <div v-if="!automations">You have no automations</div>
                        </div>
                    </div>

                    <edit-timed-automation v-bind:automation="automationToAdd" v-if="showEditTimedAutomationDialog"/>
                </template>



                <!-- ======================================================================================= -->
                <!-- ======================================================================================= -->
                <!--                                                                                         -->
                <!-- EVENT DRIVEN                                                                            -->
                <!--                                                                                         -->
                <!-- ======================================================================================= -->
                <!-- ======================================================================================= -->
                <template v-if="isTabEvent">

                    <div class="d-none d-sm-block">
                        <h2>Event <span class="d-none d-sm-inline">driven automations</span></h2>
                    </div>

                    <div class="automations__view">
                        <div class="automations__view--desktop">
                            <div class="automations-heading">
                                <div class="automations-heading__event">
                                </div>
                                <div class="automations-heading__journey">
                                    <h3>Event</h3>
                                </div>
                                <div class="automations-heading__automations">
                                    <h3>Automations</h3>
                                </div>
                            </div>

                            <div class="automations-list-scrollable">
                                <div v-for="(automation, index) in eventAutomations"
                                    v-bind:key="automation.reference"
                                    class="automation-event "
                                    v-bind:class="{'automation-event--first' : index === 0, 'automation-event--not-first' : index !== 0}"
                                    v-show="showFlow">

                                    <div class="automation-event-timeline-arrow automation-event-timeline-arrow-in">
                                        <i class="fas fa-angle-right"></i>
                                    </div>

                                    <div class="automation-event-timeline">
                                        <div class="automation-event-timeline-line"></div>
                                        <div class="automation-event-timeline-event">
                                            <span v-html="changeAutomationTriggerAsIcon(automation.trigger)" class="automation-event-timeline-event--icon"></span><br/>
                                            <span v-html="changeAutomationTriggerAsString(automation.trigger)"></span><br/>
                                        </div>
                                        <div class="automation-event-timeline-line"></div>
                                    </div>

                                    <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                        <i class="fas fa-angle-right"></i>
                                    </div>

                                    <div class="automation-event-timeline-automation">

                                        <event-automation v-bind:automation="automation"
                                                        v-bind:hideToggle="hideAutomationToggle(automation)"
                                                        v-bind:index="index"
                                                        v-bind:previousAutomation="eventAutomations[index-1]"
                                                        v-bind:nextAutomation="eventAutomations[index+1]"/>
                                    </div>
                                </div>


                                <div class="automation-event automation-event--first" v-show="showFlow">
                                    <div class="automation-event-timeline-arrow automation-event-timeline-arrow-in">
                                        <i class="fas fa-angle-right"></i>
                                    </div>

                                    <div class="automation-event-timeline">
                                        <div class="automation-event-timeline-line"></div>
                                        <div class="automation-event-timeline-event automation-event-timeline-event--add-automation">
                                            <i class="fas fa-question"></i><br/>
                                        </div>
                                        <div class="automation-event-timeline-line"></div>
                                    </div>

                                    <div class="automation-event-timeline-group automation-event-timeline-group--add-automation">
                                        <div class="automation-event-timeline-arrow automation-event-timeline-arrow-out">
                                            <i class="fas fa-angle-right"></i>
                                        </div>

                                        <div class="automation-event-timeline-add-automation">
                                            <button v-on:click.stop="addAutomation('event')" class="btn btn-primary">Add an Automation</button>
                                            <span>to execute <b>when an event triggers a change</b></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <edit-event-automation v-bind:automation="automationToAdd" v-if="showEditEventAutomationDialog"/>

                </template>

            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    import {automationsMixin} from '../mixins/AutomationsMixin'
    import {whatsAppTemplatesMixin} from "../mixins/WhatsAppTemplatesMixin"

    import Spinner from '../components/Spinner.vue'
    import Automation from '../components/automations/TimedAutomation.vue'
    import TimedAutomation2 from '../components/automations/TimedAutomation2.vue'
    import EditTimedAutomation from '../components/automations/EditTimedAutomation.vue'
    import EventAutomation from '../components/automations/EventAutomation.vue'
    import EditEventAutomation from '../components/automations/EditEventAutomation.vue'

    import { store } from '../store.js'

    const TAB_TIMED = 0, TAB_EVENT = 1;

    export default {
        name: "Automations.vue",
        components: { Spinner, TimedAutomation2, EditTimedAutomation, Automation, EventAutomation, EditEventAutomation },
        mixins: [automationsMixin, whatsAppTemplatesMixin],
        data: function () {
            return {
                tab: TAB_TIMED,
                automations: [],
                eventAutomations: [],
                showFlow: true,
                loading: true,
                pageNumber: 0,
                afterBooking: [],
                beforeCheckIn: [],
                afterCheckIn: [],
                beforeCheckOut: [],
                afterCheckOut: [],
                afterBookingGroups: [],
                beforeCheckInGroups: [],
                afterCheckInGroups: [],
                beforeCheckOutGroups: [],
                afterCheckOutGroups: [],
                automationToAdd: {},
                showEditTimedAutomationDialog: false,
                showEditEventAutomationDialog: false
            }
        },
        computed: {
            isTabTimed: function() {
                return this.tab === TAB_TIMED;
            },
            isTabEvent: function() {
                return this.tab === TAB_EVENT;
            },
            flows: function() {
                return [ this.afterBooking, this.beforeCheckIn, this.afterCheckIn, this.beforeCheckOut, this.afterCheckOut ];
            },
            hasAutomations: function() {
                return this.automations.length > 0;
            }
        },
        methods: {
            startTour: function () {
                const tour = this.$shepherd({
                    useModalOverlay: true,
                    defaultStepOptions: {
                        classes: "shepherd-popup",
                        cancelIcon: {
                            enabled: true
                        },
                        scrollTo: {behavior: 'smooth', block: 'center'}
                    }
                });

                tour.addStep({
                    id: "automation-types",
                    text: 'There are 2 types of Automations: <b>time-driven</b> and <b>event-driven</b>. ' +
                        '<br/><br/>Time-driven Automations trigger ' +
                        'based on a Booking\'s timings, such as when a Booking is placed or the check-in date. ' +
                        '<br/><br/>We suggest you start with time-driven Automations',
                    attachTo: {element: this.$refs.automationTypeTimed, on: 'right'},
                    buttons: [
                        {
                            text: 'Next',
                            action: tour.next
                        }
                    ]
                });
                tour.addStep({
                    id: "timeline",
                    text: 'There are 3 dates around which you can configure a time-driven Automation: <ol>' +
                        '<li>when the <b>Booking</b> is <b>placed</b></li>' +
                        '<li>the <b>check-in</b> date</li>' +
                        '<li>the <b>check-out</b> date</li>' +
                        '</ol>',
                    attachTo: {element: this.$refs.timelineBookingPlaced, on: 'bottom'},
                    buttons: [
                        {
                            text: 'Next',
                            action: tour.next
                        }
                    ]
                });
                tour.addStep({
                    id: "addAutomationButton",
                    text: 'Use the <b>AddAutomation</b> buttons to create a new Automation',
                    attachTo: {element: this.$refs.addAutomation, on: 'bottom'},
                    buttons: [
                        {
                            text: 'Next',
                            action: (this.hasAutomations) ? tour.complete : tour.next
                        }
                    ]
                });

                if (this.automations.length === 0) {
                    tour.addStep({
                        id: "addAutomation",
                        text: 'We see that you chose not to add an Automation while signing up, and suggest that you ' +
                            'start by adding a simple Automation like <b>sending an Email</b> when a Booking is placed.',
                        buttons: [
                            {
                                text: 'Next',
                                action: tour.next
                            }
                        ]
                    });
                    tour.addStep({
                        id: "complete",
                        text: 'That concludes your tour. If you need assistance, our support team are always here to help you.',
                        buttons: [
                            {
                                text: 'Done',
                                action: tour.complete
                            }
                        ]
                    });
                }

                tour.on("complete", () => {
                    if (this.hasAutomations) {
                        this.$root.$emit("tour-start-automation-tour", this.automations[0].reference)
                    } else {
                        this.$root.$emit("tour-welcome-complete")
                    }
                })

                tour.start();
            },
            showTimedAutomations: function() {
                this.tab = TAB_TIMED;
            },
            showEventAutomations: function() {
                this.tab = TAB_EVENT;
            },
            changeViewFlow: function(showFlow) {
                this.showFlow = showFlow;
            },
            automationTypeAsIcon: function(type) {
                switch (type) {
                    case 'send-email':
                        return '<i class="fas fa-envelope" aria-hidden="true"></i>'
                    case 'send-sms':
                        return '<i class="fas fa-sms" aria-hidden="true"></i>'
                    case 'send-whatsapp':
                        return '<i class="fas fa-comments" aria-hidden="true"></i>'
                    case 'send-omni-channel-guest-form':
                    case 'guest-form':
                        return '<i class="fab fa-wpforms" aria-hidden="true"></i>'
                    case 'pdf-form-response':
                        return '<i class="far fa-file-pdf"></i>';
                    case 'to-do':
                        return '<i class="fas fa-list" aria-hidden="true"></i>'
                    case 'send-omni-channel':
                        return '<i class="fas fa-envelope" aria-hidden="true"></i><i class="fas fa-sms" aria-hidden="true"></i>'
                    case 'upsell':
                        return '<i class="fas fa-cart-plus" aria-hidden="true"></i>'
                }
                return "";
            },
            changeAutomationTriggerAsIcon: function(trigger) {
                switch (trigger) {
                    case 'booking-placed':
                        return '<i class="fas fa-envelope" aria-hidden="true"></i>'
                    case 'booking-deposit-received':
                        return '<i class="fas fa-coins"></i>'
                    case 'booking-total-paid':
                        return '<i class="fas fa-coins"></i>'
                    case 'booking-account-overdue':
                        return '<i class="fas fa-coins"></i>'
                    case 'booking-details-changed':
                        return '<i class="fas fa-calendar-check"></i>'
                    case 'booking-cancelled':
                        return '<i class="fas fa-ban"></i>';
                    case 'form-complete':
                        return '<i class="fas fa-check"></i>'
                }
                return "";
            },
            changeAutomationTriggerAsString: function(trigger) {
                switch (trigger) {
                    case 'booking-deposit-received':
                        return 'Deposit<br/>Received'
                    case 'booking-total-paid':
                        return 'Total<br/>Paid'
                    case 'booking-account-overdue':
                        return 'Account<br/>Overdue'
                    case 'booking-placed':
                        return 'Booking<br/>Placed'
                    case 'booking-details-changed':
                        return 'Booking<br/>Changed'
                    case 'booking-cancelled':
                        return 'Booking<br/>Cancelled'
                    case 'form-complete':
                        return 'Form<br/>Completed'
                }
                return "";
            },
            showAddAutomationButtonBefore(beforeAutomations, afterAutomations) {
                let hasBeforeAutomations = beforeAutomations && beforeAutomations.length > 0;
                let hasAtAutomations = afterAutomations && afterAutomations.length > 0 && afterAutomations[0].numberOfDaysFrom === 0;
                let hasAfterAutomations = afterAutomations && afterAutomations.length > 0;
                if (!hasBeforeAutomations && !hasAtAutomations && !hasAfterAutomations) {
                    return false;
                }
                return true;
            },
            showAddAutomationButtonAt(beforeAutomations, afterAutomations) {
                return !this.showAddAutomationButtonBefore(beforeAutomations, afterAutomations);
            },
            showAddAutomationButtonAfter(beforeAutomations, afterAutomations) {
                return this.showAddAutomationButtonBefore(beforeAutomations, afterAutomations);
            },
            whenStrategy: function(when) {
                let result = Math.abs(when.numberOfDaysFrom);
                if (result === 1) {
                    result += " day ";
                } else {
                    result += " days ";
                }
                switch (when.strategy) {
                    case 'immediate':
                        return "Immediately";
                    default:
                        if (when.numberOfDaysFrom === 0) {
                            return "On day";
                        } else if (when.numberOfDaysFrom < 0) {
                            return result + "before";
                        } else {
                            return result + "after";
                        }
                }
            },
            automationTypeAsString: function(type) {
                switch (type) {
                    case 'send-email':
                        return "Send email";
                    case 'send-sms':
                        return "Send SMS";
                    case 'send-whatsapp':
                        return "Send WhatsApp";
                    case 'send-omni-channel-guest-form':
                        return "Form";
                    case 'guest-form':
                        return "Front desk Form";
                    case 'pdf-form-response':
                        return "PDF a form response";
                    case 'to-do':
                        return "Create To Do";
                    case 'send-omni-channel':
                        return "Send Email and SMS";
                    case 'upsell':
                        return "Upsell";
                }
                return "";
            },
            automationFlow: function(when) {
                console.log(when.strategy);
                switch (when.strategy) {
                    case 'immediate':
                    case 'after-booking':
                        return "Booking";
                    case 'before-or-after-arrival':
                        return "Check-In";
                    case 'before-or-after-departure':
                        return "Check-Out";
                }
                return "";
            },
            hideAutomationToggle: function(automation) {
                if (this.isAnAutomationWhatsApp(automation) && !this.isWhatsAppTemplateApproved(automation.whatsAppTemplateReference)) {
                    return true;
                }
                return false;
            },
            fetchAutomations: async function () {
                this.loading = true;
                this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/automations', {
                    withCredentials: true
                }).then(response => {
                    this.automations.splice(0, this.automations.length);
                    this.eventAutomations.splice(0, this.eventAutomations.length);
                    this.afterBooking.splice(0, this.afterBooking.length);
                    this.afterBookingGroups.splice(0, this.afterBookingGroups.length);
                    this.beforeCheckIn.splice(0, this.beforeCheckIn.length);
                    this.beforeCheckInGroups.splice(0, this.beforeCheckInGroups.length);
                    this.afterCheckIn.splice(0, this.afterCheckIn.length);
                    this.afterCheckInGroups.splice(0, this.afterCheckInGroups.length);
                    this.beforeCheckOut.splice(0, this.beforeCheckOut.length);
                    this.beforeCheckOutGroups.splice(0, this.beforeCheckOutGroups.length);
                    this.afterCheckOut.splice(0, this.afterCheckOut.length);
                    this.afterCheckOutGroups.splice(0, this.afterCheckOutGroups.length);
                    this.automations.push(...response.data);
                    this.setAppliedToAllBookingsOnAllAutomations(this.automations);
                    this.sortAllAutomations(this.automations);
                    this.allocateAutomationsToFlows();
                }).catch(error => {
                    console.log(error)
                }).finally(() => {
                    this.loading = false
                })
            },
            allocateAutomationsToFlows: function() {
                this.automations.forEach((automation) => {
                    this.allocateAutomationToFlow(automation);
                });
            },
            sortAutomationFlowGroupsByNumberOfDaysFrom: function(groups) {
                groups.sort(this.compareGroupsByNumberOfDaysFrom);
            },
            compareGroupsByNumberOfDaysFrom: function (first, second) {
                if (first.numberOfDaysFrom > second.numberOfDaysFrom) {
                    return 1;
                } else if (parseInt(first.numberOfDaysFrom) < parseInt(second.numberOfDaysFrom)) {
                    return -1;
                } else {
                    return 0;
                }
            },
            calculateDayIncrementsForFlow: function(flow, startFromFront) {
                if (startFromFront) {
                    for (let i = 0, dayGap = 0; i < flow.length; i++) {
                        flow[i].dayIncrement = flow[i].when.numberOfDaysFrom - dayGap;
                        dayGap = flow[i].when.numberOfDaysFrom;
                    }
                } else {
                    for (let i = flow.length-1, dayGap = 0; i >= 0; i--) {
                        flow[i].dayIncrement = flow[i].when.numberOfDaysFrom - dayGap;
                        dayGap = flow[i].when.numberOfDaysFrom;
                    }
                }
            },
            allocateAutomationToFlow: function(automation) {
                switch (automation.trigger) {
                    case 'booking-placed':
                        switch (automation.when.strategy) {
                            case 'immediate':
                                this.afterBooking.push(automation);
                                this.sortAutomationFlowByNumberOfDaysFrom(this.afterBooking);
                                this.allocateAutomationToFlowGroup(this.afterBookingGroups, automation);
                                this.sortAutomationFlowGroupsByNumberOfDaysFrom(this.afterBookingGroups);
                                this.calculateDayIncrementsForFlow(this.afterBooking, true);
                                break;
                            case 'after-booking':
                                this.afterBooking.push(automation);
                                this.sortAutomationFlowByNumberOfDaysFrom(this.afterBooking);
                                this.allocateAutomationToFlowGroup(this.afterBookingGroups, automation);
                                this.sortAutomationFlowGroupsByNumberOfDaysFrom(this.afterBookingGroups);
                                this.calculateDayIncrementsForFlow(this.afterBooking, true);
                                break;
                            case 'before-or-after-arrival':
                                if (automation.when.numberOfDaysFrom < 0) {
                                    this.beforeCheckIn.push(automation);
                                    this.sortAutomationFlowByNumberOfDaysFrom(this.beforeCheckIn);
                                    this.allocateAutomationToFlowGroup(this.beforeCheckInGroups, automation);
                                    this.sortAutomationFlowGroupsByNumberOfDaysFrom(this.beforeCheckInGroups);
                                    this.calculateDayIncrementsForFlow(this.beforeCheckIn, false);
                                } else {
                                    this.afterCheckIn.push(automation);
                                    this.sortAutomationFlowByNumberOfDaysFrom(this.afterCheckIn);
                                    this.allocateAutomationToFlowGroup(this.afterCheckInGroups, automation);
                                    this.sortAutomationFlowGroupsByNumberOfDaysFrom(this.afterCheckInGroups);
                                    this.calculateDayIncrementsForFlow(this.afterCheckIn, true);
                                }
                                break;
                            case 'before-or-after-departure':
                                if (automation.when.numberOfDaysFrom < 0) {
                                    this.beforeCheckOut.push(automation);
                                    this.sortAutomationFlowByNumberOfDaysFrom(this.beforeCheckOut);
                                    this.allocateAutomationToFlowGroup(this.beforeCheckOutGroups, automation);
                                    this.sortAutomationFlowGroupsByNumberOfDaysFrom(this.beforeCheckOutGroups);
                                    this.calculateDayIncrementsForFlow(this.beforeCheckOut, false);
                                } else {
                                    this.afterCheckOut.push(automation);
                                    this.sortAutomationFlowByNumberOfDaysFrom(this.afterCheckOut);
                                    this.allocateAutomationToFlowGroup(this.afterCheckOutGroups, automation);
                                    this.sortAutomationFlowGroupsByNumberOfDaysFrom(this.afterCheckOutGroups);
                                    this.calculateDayIncrementsForFlow(this.afterCheckOut, true);
                                }
                                break;
                        }
                    break;
                    default:
                        this.eventAutomations.push(automation);
                        this.sortEventAutomations();
                }
            },
            allocateAutomationToFlowGroup: function(groupedByTimeTypeAndCommunicationMode, automation) {
                let groupedByTime = null;
                for (let group of groupedByTimeTypeAndCommunicationMode) {
                    if (group.numberOfDaysFrom === automation.when.numberOfDaysFrom) {
                        groupedByTime = group;
                        break;
                    }
                }
                if (groupedByTime === null) {
                    groupedByTime = {
                        numberOfDaysFrom: automation.when.numberOfDaysFrom,
                        groupedByTypeAndCommunicationMode: []
                    };
                    groupedByTimeTypeAndCommunicationMode.push(groupedByTime);
                }
                this.allocateAutomationToGroupedByTypeAndCommunicationModeWithinTimeGroup(groupedByTime, automation);
            },
            allocateAutomationToGroupedByTypeAndCommunicationModeWithinTimeGroup: function(groupedByTime, automation) {
                let groupedByTypeAndCommunicationMode = null;
                for (let group of groupedByTime.groupedByTypeAndCommunicationMode) {
                    if (group.type === automation.type && group.communicationMode === automation.communicationMode) {
                        groupedByTypeAndCommunicationMode = group;
                        break;
                    }
                }
                if (groupedByTypeAndCommunicationMode === null) {
                    groupedByTypeAndCommunicationMode = {
                        type: automation.type,
                        communicationMode: automation.communicationMode,
                        automations: []
                    };
                    groupedByTime.groupedByTypeAndCommunicationMode.push(groupedByTypeAndCommunicationMode);
                }
                groupedByTypeAndCommunicationMode.automations.push(automation);
                groupedByTypeAndCommunicationMode.automations.sort((a, b) => {
                    if (a.name < b.name) {
                        return -1;
                    } else if (a.name > b.name) {
                        return 1;
                    } else {
                        if (a.reference < b.reference) {
                            return -1;
                        } else {
                            return 1;
                        }
                    }
                });
                // Sort the groups by type then communication mode.
                // The order is not too critical, but being consistent is (especially when updating an Automation, we
                // don't always want it to slip to the end, which is what was happening)
                groupedByTime.groupedByTypeAndCommunicationMode.sort((a, b) => {
                    if (a.type < b.type) {
                        return -1;
                    } else if (a.type > b.type) {
                        return 1;
                    } else {
                        return a.communicationMode.localeCompare(b.communicationMode);
                    }
                });
            },
            sortEventAutomations: function() {
                this.eventAutomations.sort((a, b) => {
                    if (a.trigger < b.trigger) {
                        return -1;
                    } else if (a.trigger > b.trigger) {
                        return 1;
                    } else {
                        return a.name.localeCompare(b.name);
                    }
                });
            },
            removeAutomationFromLists: function(automationReference) {
                this.removeAutomationFromList(this.automations, automationReference);
                this.removeAutomationFromList(this.eventAutomations, automationReference);
                this.removeAutomationFromList(this.afterBooking, automationReference);
                this.removeAutomationFromList(this.beforeCheckIn, automationReference);
                this.removeAutomationFromList(this.afterCheckIn, automationReference);
                this.removeAutomationFromList(this.beforeCheckOut, automationReference);
                this.removeAutomationFromList(this.afterCheckOut, automationReference);

                this.removeAutomationFromFlowGroup(this.afterBookingGroups, automationReference);
                this.removeAutomationFromFlowGroup(this.beforeCheckInGroups, automationReference);
                this.removeAutomationFromFlowGroup(this.afterCheckInGroups, automationReference);
                this.removeAutomationFromFlowGroup(this.beforeCheckOutGroups, automationReference);
                this.removeAutomationFromFlowGroup(this.afterCheckOutGroups, automationReference);
            },
            removeAutomationFromList: function(automations, automationReference) {
                for (let index = 0; index < automations.length; index++) {
                    if ((typeof automationReference === 'undefined' && typeof automations[index].reference === 'undefined') ||
                        (automations[index].reference === automationReference)) {
                        automations.splice(index, 1);
                        return;
                    }
                }
            },
            removeAutomationFromFlowGroup: function(groupedByTimeTypeAndCommunicationMode, automationReference) {
                let found = false;
                for (let i = 0; i < groupedByTimeTypeAndCommunicationMode.length; i++) {
                    for (let j = 0; j < groupedByTimeTypeAndCommunicationMode[i].groupedByTypeAndCommunicationMode.length; j++) {
                        for (let k = 0; k < groupedByTimeTypeAndCommunicationMode[i].groupedByTypeAndCommunicationMode[j].automations.length; k++) {
                            if ((typeof automationReference === 'undefined' && typeof groupedByTimeTypeAndCommunicationMode[i].groupedByTypeAndCommunicationMode[j].automations[k].reference === 'undefined') ||
                                (groupedByTimeTypeAndCommunicationMode[i].groupedByTypeAndCommunicationMode[j].automations[k].reference === automationReference)) {
                                found = true;
                                groupedByTimeTypeAndCommunicationMode[i].groupedByTypeAndCommunicationMode[j].automations.splice(k, 1);
                                break;
                            }
                        }
                        if (found) {
                            if (groupedByTimeTypeAndCommunicationMode[i].groupedByTypeAndCommunicationMode[j].automations.length === 0) {
                                groupedByTimeTypeAndCommunicationMode[i].groupedByTypeAndCommunicationMode.splice(j, 1);
                            }
                            break;
                        }
                    }
                    if (found) {
                        if (groupedByTimeTypeAndCommunicationMode[i].groupedByTypeAndCommunicationMode.length === 0) {
                            groupedByTimeTypeAndCommunicationMode.splice(i, 1);
                        }
                        break;
                    }
                }
                console.log("Removing automation = found? " + found);
            },
            scrollToAutomation: function(automationTop, automationLeft, scrollContainerReference) {
                this.$nextTick(() => {
                    const parent = this.$refs[scrollContainerReference];
                    const parentRect = parent.getBoundingClientRect();
                    const top = automationTop - parentRect.top + parent.scrollTop - 20;
                    const left = automationLeft - parentRect.left + parent.scrollLeft;
                    this.$refs[scrollContainerReference].scrollTo({ top: top, left: left, behavior: 'smooth' });
                });
            },
            openFormTemplate: function (automation) {
                this.$router.push({ 
                    name: 'EditFormTemplate', 
                    params: { reference: automation.formTemplateReference },
                    query: { parentAutomation: automation.reference }
                })
            },
            openEmailTemplate: function (automation) {
                if (this.isAnAutomationWithAForm(automation)) {
                    this.$router.push({
                        name: 'EditEmailTemplate',
                        params: { reference: automation.emailTemplateReference },
                        query: { requiredVariables: "formURL", parentAutomation: automation.reference }
                    })
                } else {
                    this.$router.push({
                        name: 'EditEmailTemplate',
                        params: { reference: automation.emailTemplateReference },
                        query: { parentAutomation: automation.reference }
                    })
                }
            },
            openSMSTemplate: function (automation) {
                if (this.isAnAutomationWithAForm(automation)) {
                    this.$router.push({
                        name: 'EditSMSTemplate',
                        params: { reference: automation.smsTemplateReference },
                        query: { requiredVariables: "formURL", parentAutomation: automation.reference }
                    })
                } else {
                    this.$router.push({
                        name: 'EditSMSTemplate',
                        params: { reference: automation.smsTemplateReference },
                        query: { parentAutomation: automation.reference }
                    })
                }
            },
            addAutomationAtIndex: function(existingAutomation, index) {
                switch(existingAutomation.when.strategy) {
                    case 'after-booking':
                    case 'immediate':
                        this.addAutomation('after-booking', index);
                        break;
                    case 'before-or-after-arrival':
                        if (existingAutomation.when.numberOfDaysFrom < 0) {
                            this.addAutomation('before-check-in', index);
                            break;
                        } else {
                            this.addAutomation('after-check-in', index);
                            break;
                        }
                    case 'before-or-after-departure':
                        if (existingAutomation.when.numberOfDaysFrom < 0) {
                            this.addAutomation('before-check-out', index);
                            break;
                        } else {
                            this.addAutomation('after-check-out', index);
                            break;
                        }
                }
            },
            addAutomation: function(flow, index = 0) {
                console.log("Adding an automation to flow: " + flow + " index: " + index);
                Vue.set(this, 'automationToAdd', { 
                        type: "", 
                        active: false, 
                        communicationMode: "guest-only", 
                        bccHost: true, 
                        when: { strategy: "after-booking", numberOfDaysFrom: 0, timeOfDay: "07:00" }, 
                        conditions: [], 
                        appliesToAllBookings: true, 
                        showBookingSummary: false, 
                        showPricing: false,
                        useDueDate: true,
                        sendSMS: false, 
                        pauseNewTasks: false 
                });
                switch (flow) {
                    case 'event':
                        Vue.set(this.automationToAdd, 'trigger', "booking-deposit-received");
                        this.automationToAdd.when.strategy = 'immediate';
                        this.automationToAdd.when.numberOfDaysFrom = 0;
                        break;
                    case 'after-booking':
                        this.automationToAdd.when.strategy = 'after-booking';
                        this.automationToAdd.when.numberOfDaysFrom = 0;
                        break;
                    case 'before-check-in':
                        this.automationToAdd.when.strategy = 'before-or-after-arrival';
                        this.automationToAdd.when.numberOfDaysFrom = -1;
                        break;
                    case 'after-check-in':
                        this.automationToAdd.when.strategy = 'before-or-after-arrival';
                        this.automationToAdd.when.numberOfDaysFrom = 1;
                        break;
                    case 'before-check-out':
                        this.automationToAdd.when.strategy = 'before-or-after-departure';
                        this.automationToAdd.when.numberOfDaysFrom = -1;
                        break;
                    case 'after-check-out':
                        this.automationToAdd.when.strategy = 'before-or-after-departure';
                        this.automationToAdd.when.numberOfDaysFrom = 1;
                        break;
                }
                switch (flow) {
                    case 'event':
                        this.$nextTick(() => {
                            this.showEditEventAutomationDialog = true;
                        });
                        break;
                    default:
                        this.$nextTick(() => {
                            this.showEditTimedAutomationDialog = true;
                        });
                        break;
                }
            },
            stopEditingAutomation: function(automation) {
                console.log("Finished editing automation");
                if (automation) {
                    this.removeAutomationFromLists(automation.reference);
                    this.allocateAutomationToFlow(automation);
                    this.scrollToEditedAutomation(automation);
                }
                this.hideAutomationDialog();
            },
            hideAutomationDialog: function() {
                this.showEditTimedAutomationDialog = false;
                this.showEditEventAutomationDialog = false;
            },
            scrollToEditedAutomation: function(automation) {
                this.$nextTick(() => {
                    this.$root.$emit('scroll-to-automation', automation.reference);
                });
            } 
        },
        mounted: async function() {
            console.log("Loading automations")
            await this.fetchAutomations();
            await this.fetchWhatsAppTemplates();

            this.$root.$on('tour-account-complete', this.startTour)

            this.$root.$on('selected-establishment', this.fetchAutomations);
            this.$root.$on('finished-editing-automation', this.stopEditingAutomation);
            this.$root.$on('add-automation', this.addAutomationAtIndex);
            this.$root.$on('duplicated-automation', this.stopEditingAutomation);
            this.$root.$on('deleted-automation', this.removeAutomationFromLists);
            this.$root.$on('delete-new-automation', this.hideAutomationDialog);
        },
        beforeDestroy () {
            this.$root.$off('tour-account-complete', this.startTour)

            this.$root.$off('selected-establishment', this.fetchAutomations);
            this.$root.$off('finished-editing-automation', this.stopEditingAutomation);
            this.$root.$off('add-automation', this.addAutomationAtIndex);
            this.$root.$off('duplicated-automation', this.stopEditingAutomation);
            this.$root.$off('deleted-automation', this.removeAutomationFromLists);
            this.$root.$off('delete-new-automation', this.hideAutomationDialog);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/layout/_pills";
    @import "../styles/layout/_tabs";
    @import "../styles/pages/_automations";
</style>